import React from 'react';


export const Layout = (props) => (
    <React.Fragment>
        {props.children}
    </React.Fragment>
)